import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './updateClaim.scss';
import { useAuth } from '@/lib/auth'
import { Loader } from '@/components/Loader/Loader';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { ReactComponent as Statusicon } from '@/assets/steam/funnel-frame.svg';
import { ReactComponent as LastCoverageIcon } from '@/assets/steam/last-coverage.svg';
import { ReactComponent as Calendericon } from '@/assets/steam/date-frame.svg';
import { ReactComponent as Coverageicon } from '@/assets/steam/coverage-frame.svg';
import { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';
import { ReactComponent as ProductIconWithBg } from '@/assets/steam/product-with-bg.svg';
import Utils from '@/utils/util';
import Dropdown from 'react-bootstrap/Dropdown';
import { ReactComponent as DownIcon } from '@/assets/steam/down-icon.svg';
import { useGetUsersList } from '@/features/users/api/getProducts';
import { User } from '@/types';
import { useGetProductGroupList, useGetProductList } from '@/features/product/api/getProduct';
import { Product } from '@/features/product/types/indes';
import { ReactComponent as BookIcon } from '@/assets/steam/quotes.svg';
import { ReactComponent as BookFunnelIcon } from '@/assets/steam/book-funnel.svg';
import { ReactComponent as ProductFunnelicon } from '@/assets/steam/product-funnel.svg';
import { QUOTES_STATUS } from '@/utils/constants';
import { useUploadAudio } from '@/features/funnel/api/uploadAudio';
import { showNotification } from '@/utils/notificationUtils';
import { useGetQuotesUpdate, useUpdateQuote } from '../api/updateQuote';
import { ReactComponent as Deleteicon } from '@/assets/steam/delete-red.svg';

const UpdateClaim: VFC<{
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    claimDetails: any;
}> = ({ open, onClose, onConfirm, claimDetails }) => {
    const { user } = useAuth();
    const item = claimDetails;
    const [showData, setShowDetails] = useState(false);
    const [setSelectedFunnelStage, setSelectedFunnelState] = useState<any>({ name: '', id: null });
    const uploadPicture = useGetQuotesUpdate();
    const [approvedAmount, setApprovedAmount] = useState<string>();
    const [uploadedPdf, setUploadedPdf] = useState<string>();
    const fileInputRef = useRef(null);
    const useCreateQuoteMutation = useUpdateQuote();
    const [comments, setComments] = useState<any>('');

    const status = [
        { id: 1, name: 'Requested' },
        { id: 2, name: 'Approved' },
        { id: 3, name: 'Rejected' },
    ]
    useEffect(() => {
        if (item) {
            const getSttaus = status.filter((details: any) => Number(details.id) === Number(item.statusId))
            if (getSttaus && getSttaus.length > 0) {

                setSelectedFunnelState({ name: getSttaus[0].name, id: getSttaus[0].id })
            }
            if (item?.approvedAmount) {
                setApprovedAmount(item?.approvedAmount)
            }

            setComments(item?.remarks)
        }

    }, [item])

    const createClaimDetails = async () => {


        const res = await useCreateQuoteMutation.mutateAsync({
            groupId: claimDetails?.id,
            remarks: comments,
            approvedAmount : approvedAmount,
            statusId: setSelectedFunnelStage?.id,

        });

        if (res) {
            setSelectedFunnelState({ name: '', id: null })
            setApprovedAmount('')
            setComments('')
            onConfirm()
        }
    }

    const validate = () => {
        let errorMessage = '';
        if (!approvedAmount
        ) {
          errorMessage = 'Please enter approved amount';
        } else if(!comments){
            errorMessage = 'Please enter remark';
        }
        if (errorMessage) {
          showNotification({
            type: 'info',
            title: errorMessage,
          });
          return false;
        }
        return true;
      };
    
    const getContent = () => {
        return (
            <div className="view-quotes-dialog-content">
                <div className='details-panel mb-2  change-display'>
                    <div className='ddd-details'>
                        {/* <div className='tags'>Update Stage</div> */}
                        <div className='s-c-detail setDispaly'>

                            <div className="user-first-last-div iscity-drp petsked-form">
                                <Dropdown className="new-figma-drop-down">
                                    <Dropdown.Toggle
                                        variant="success"
                                        className="drop-down-btn claim-width dropdown-toggle"
                                        id="dropdown-basic"
                                    >
                                        {setSelectedFunnelStage?.name ? setSelectedFunnelStage.name : 'Select stage'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="Duration-drop-down">
                                        {status?.map((item: any, index: any) => {
                                            return (
                                                <Dropdown.Item
                                                    key={index}
                                                    onClick={() => {
                                                        setSelectedFunnelStage.name = item.name
                                                        setSelectedFunnelStage.id = item.id
                                                        setSelectedFunnelState({ ...setSelectedFunnelStage })

                                                    }}
                                                    eventKey={item.name}
                                                >
                                                    <div className="menu-item-minutes">{item.name}</div>
                                                </Dropdown.Item>
                                            );
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>

                            <div className='s-c-detail-add'>
                            <input
                                className={`custome-input font-size-16`}
                                placeholder={'Enter Approved Amount'}
                                onChange={(e) => {
                                    setApprovedAmount(e.target.value);
                                }}
                                value={approvedAmount}
                                id="name"
                                type="number"
                            />
                        </div>
                        </div>

                    </div>


                </div>


                <div className='user-first-last-div'>
                        <textarea
                            className="new-cust-input message-input-funnel font-size-16"
                            placeholder="Enter remark..."
                            onChange={(ev) => setComments(ev.target.value)}
                            value={comments}
                        />
                    </div>


                <div className='divider'></div>
                <div className='quotes-list'>
                    <div className='quotes-detail'>
                        <div className='quotes-title'>
                            <div className='quote-name'>

                                <div className='iconn'>
                                    <BookIcon />

                                </div>
                                {console.log("asdasad", item)}
                                <div className='datee'>
                                    <div className='bq'>
                                        {item.title}
                                    </div>
                                    <div className='dq'>
                                        Requested date - {item.submittedDate ? Utils.formatAnyDate(item?.submittedDate) : ''}
                                    </div>

                                </div>

                            </div>
                            <div className='quote-amount'>
                            Total Claim Amount <span>₹ {Utils.convertDealSize(Number(item?.requestedAmount))}</span>
                            </div>

                        </div>

                        <div className='quote-current-status'>

                            <div className='quote-type'>
                                <div className='type-title'>
                                    Requested by
                                </div>
                                <div className='type-name display-flex'>
                                    {item?.createdByUser?.name} <div className='address-desc'>{`(${item?.createdByUser?.email})`}</div>
                                </div>

                            </div>


                            <div className='quote-type'>
                                <div className='type-title'>
                                    Total Claims
                                </div>
                                <div className='type-name'>
                                    {item?.claims?.length} Claim  <DownIcon onClick={() => {

                                        if (showData) {
                                            setShowDetails(false);
                                            //setShowDetails(item.id)
                                        } else {
                                            setShowDetails(true);
                                        }
                                    }} />
                                </div>

                            </div>


                            {showData && item && item?.claims && item?.claims.length > 0 && <div className='product-details-tab'>

                                <div className='product-header' >
                                    <div className='prod-left'>
                                        <div className='name'>
                                            Category
                                        </div>
                                        <div className='qty'>
                                            Amount
                                        </div>
                                    </div>

                                    <div className='prod-right'>
                                        <div>
                                            Image
                                        </div>
                                    </div>

                                </div>
                                {item && item?.claims && item?.claims.length > 0 && item?.claims.map((value: any, index: any) => {
                                    const lastIndex = item.claims.length - 1;
                                    return (
                                        <>
                                        <div className='product-values' key={index}>
                                            <div className='prod-left'>
                                                <div className='name'>
                                                    {value?.category}
                                                </div>
                                                <div className='qty'>
                                                    {Utils.convertDealSize(Number(value?.amount))}
                                                </div>
                                            </div>

                                            {value?.photoLink && <div className='prod-right' >
                                                <div onClick={() => window.open(value?.photoLink, '_blank')}>
                                                Download Image
                                                </div>

                                            </div>}

                                        </div>
                                        <div>
                                        <div className={`product-values ${index !== lastIndex  ? 'border-bottom' : ''}`}>
                                 <div className='prod-left'>
                                 
                                 <div className='name'>
                                 Claim Details
                                                </div>
                                                <div className='qty'>
                                                    {value?.remark}
                                                </div>
                                 </div>
 
                             </div>
                                        </div>
                                        </>
                                    )
                                })}




                            </div>}



                        </div>

                    </div>
                </div>


            </div>
        );
    };
    return (
        <>
            <Modal
                show={open}
                onHide={() => {
                    onClose();  setSelectedFunnelState({ name: '', id: null })
                    setApprovedAmount('')
                    setComments('')
                }}
                className={`steam-modal-dialog update-quotes-dialog`}
                size="sm"

            >
                <Modal.Header closeButton >
                    <div className="model-header-tab">
                        <div className="modal-header-title">
                             Claim <span className={`${setSelectedFunnelStage?.name === 'Approved' ? 'approved' : setSelectedFunnelStage?.name === 'Rejected' ? 'rejected': ''}`}>{setSelectedFunnelStage?.name}</span> 
                        </div>
                        <div className="modal-header-desc">
                            {/* {'Lorem ipsum dolor sit amet, consectetur elit, sed'} */}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body >{getContent()}</Modal.Body>
                <Modal.Footer>
                    <div className="btn-container display-flex">
                        <button
                            className={`steam-button button-dark display-flex `}
                            onClick={async () => {
                                if(setSelectedFunnelStage && Number(setSelectedFunnelStage.id) === 3){
                                    createClaimDetails();
                                }else{
                                    if(validate()){
                                        createClaimDetails();
                                    }
                                }
                                
                            }}
                            disabled={ Number(claimDetails?.statusId)=== 2}
                        >
                            <span> {'Update'}</span>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};




export default UpdateClaim;
